import { useMemo } from 'react';

export default function useRowId(){
  const createRow = () => {
    return  {
      "id": "new-" + Math.round((Math.random()*1000000 + 10000)), //TODO: Some proper uuid
      "editable": true,
    } 
  };

  const getRowId = useMemo(() => {
    return (params) => params.data.id ? `${params.data.id}` : Math.random().toString();
  }, []);

  return [createRow, getRowId];
}